import React, { Component } from 'react';

import TabPlayers from './tabDetail/tabPlayers';
import TabLicences from './tabDetail/tabLicences';
import TabPayment from './tabDetail/tabPayments';
import TabPromo from './tabDetail/tabPromo';
import TabVpnPass from './tabDetail/tabVpnPass';
import TabVpnBox from './tabDetail/tabVpnBox';
import { controlRole } from '../../common/actions/controlRole';

/**
 * Tab del dettaglio utente. Vengono mostrati solo quelli per cui l'utente del back office ha i permessi.
 */
const TABS = [
    { id: 'Player', label: 'Player', icon: 'fas fa-play-circle', allowed: (role) => controlRole(role.player, "api/Player/GetPlayers", "GET") },
    { id: 'Licence', label: 'Licenze', icon: 'fas fa-key', allowed: (role) => controlRole(role.player, "api/Player/GetLicences", "GET") },
    { id: 'Payments', label: 'Pagamenti', icon: 'fas fa-money-bill', allowed: (role) => controlRole(role.payment, "api/Payment", "GET") },
    // le promo esistono solo per gli utenti registrati
    { id: 'Promo', label: 'Promo', icon: 'fas fa-gift', allowed: (role, user) => user.isRegistered && controlRole(role.promo, "api/Promo", "GET") },
    { id: 'Pass', label: 'VPN Pass', icon: 'fas fa-user-shield', allowed: (role) => controlRole(role.vpnPass, "api/VpnPass", "GET") },
    { id: 'Box', label: 'VPN Box', icon: 'fas fa-user-lock', allowed: (role) => controlRole(role.vpnBox, "api/VpnBox", "GET") },
];

export default class contentDetailUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabActive: 'Player',
        }
    }

    renderTab(id) {
        const {
            userInDetail, errorNotify, successNotify, warningNotify, infoNotify, setIdPaymentForDetail, setIdVpnPassForDetail,
            setKeyVpnPassForDetail, setIdPlayerForDetail, removeVpnPass,
            userId, role, group, preferences, productList, promo,
            sendNewPromo, sendEditPromo, deletePromo, getPromoList, getPaymentList, payment, deletePayment, deactiveSub, refundPayment, getLicenceList,
            handleNavigation
        } = this.props;

        const notify = { errorNotify, successNotify, warningNotify, infoNotify };

        switch (id) {
            case 'Player':
                return <TabPlayers userInDetail={userInDetail} userId={userId} role={role} handleNavigation={handleNavigation} {...notify} />;

            case 'Licence':
                return <TabLicences userInDetail={userInDetail} userId={userId} getLicenceList={getLicenceList} {...notify} />;

            case 'Payments':
                return (
                    <TabPayment
                        userInDetail={userInDetail}
                        userId={userId}
                        setIdVpnPassForDetail={setIdVpnPassForDetail}
                        setIdPlayerForDetail={setIdPlayerForDetail}
                        getPaymentList={getPaymentList}
                        payment={payment}
                        deletePayment={deletePayment}
                        deactiveSub={deactiveSub}
                        refundPayment={refundPayment}
                        handleNavigation={handleNavigation}
                        role={role}
                        {...notify}
                    />
                );

            case 'Promo':
                return (
                    <TabPromo
                        userInDetail={userInDetail}
                        userId={userId}
                        productList={productList}
                        getPromoList={getPromoList}
                        group={group}
                        preferences={preferences}
                        promo={promo}
                        sendNewPromo={sendNewPromo}
                        sendEditPromo={sendEditPromo}
                        deletePromo={deletePromo}
                        role={role}
                        {...notify}
                    />
                );

            case 'Pass':
                return (
                    <TabVpnPass
                        userInDetail={userInDetail}
                        userId={userId}
                        setIdPaymentForDetail={setIdPaymentForDetail}
                        removeVpnPass={removeVpnPass}
                        handleNavigation={handleNavigation}
                        role={role}
                        {...notify}
                    />
                );

            case 'Box':
                return (
                    <TabVpnBox
                        userInDetail={userInDetail}
                        userId={userId}
                        setKeyVpnPassForDetail={setKeyVpnPassForDetail}
                        handleNavigation={handleNavigation}
                        role={role}
                        {...notify}
                    />
                );

            default:
                return null;
        }
    }

    render() {
        const { role, userInDetail } = this.props;
        const tabs = TABS.filter(tab => tab.allowed(role, userInDetail));

        // se il tab selezionato non è disponibile (es. permessi), mostro il primo consentito
        const active = tabs.some(tab => tab.id === this.state.tabActive) ? this.state.tabActive : (tabs[0] && tabs[0].id);

        if (!tabs.length) {
            return <div className="uiCard"><div className="uiEmpty">Non hai i permessi per vedere i dati di questo utente</div></div>;
        }

        return (
            <>
                <div className="udTabs" role="tablist" aria-label="Dati dell'utente">
                    {
                        tabs.map(tab => (
                            <button
                                key={tab.id}
                                type="button"
                                role="tab"
                                aria-selected={active === tab.id}
                                className={`udTab${active === tab.id ? ' isActive' : ''}`}
                                onClick={() => this.setState({ tabActive: tab.id })}
                            >
                                <i className={tab.icon} aria-hidden="true" />
                                {tab.label}
                            </button>
                        ))
                    }
                </div>

                <div className="uiCard udTabPanel" role="tabpanel">
                    {this.renderTab(active)}
                </div>
            </>
        );
    }
}
